import { render, staticRenderFns } from "./book-card.vue?vue&type=template&id=8329d5a6&scoped=true"
import script from "./book-card.vue?vue&type=script&lang=ts"
export * from "./book-card.vue?vue&type=script&lang=ts"
import style0 from "./book-card.vue?vue&type=style&index=0&id=8329d5a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8329d5a6",
  null
  
)

export default component.exports